import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from './app/router';
import { App } from './app/App';
import { AppErrorBoundary } from './app/AppErrorBoundary';
import { AutoFocusManager } from './components/AutoFocusManager';
import { NativeInteractionManager } from './components/NativeInteractionManager';
import { LanguageProvider } from './i18n/i18n';
import './styles/global.css';

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      void navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
    });
  } else {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(registrations.map((registration) => registration.unregister()))
      );
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <AppErrorBoundary>
          <AutoFocusManager />
          <NativeInteractionManager />
          <App />
        </AppErrorBoundary>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>
);
